<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7 5.5 3.5 9 7 12.5M3.5 9h8.2a4.3 4.3 0 0 1 0 8.6H8"/></svg>
</template>
